import { render, staticRenderFns } from "./SupportList.vue?vue&type=template&id=41074310&"
import script from "./SupportList.vue?vue&type=script&lang=js&"
export * from "./SupportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports